import { useEffect, useState } from 'react';
import useModalState from '@sdk/components/ui/modal/useModalState';

import {
  useConversationActions,
  useConversationState,
} from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';
import { useEditMessageAction } from '@web/conversations/Conversation/ConversationProvider/hooks/useEditMessageAction';
import { Attachment } from '@web/conversations/types/Attachment';
import { MessagePost } from '@web/conversations/types/Message';

export function useMessageEditModal() {
  const { open, close, isVisible } = useModalState();

  const { messages, editMessageId } = useConversationState();

  const { setEditMessage } = useConversationActions();
  const { action } = useEditMessageAction();
  const editedMessage = messages.byId[editMessageId] as MessagePost;

  useEffect(() => {
    if (editedMessage) open();
  }, [editedMessage, open]);

  const onSubmit = async (content: { text: string; attachments: Attachment[] }) => {
    const updatedMessage = {
      ...editedMessage,
      parentMessage: editedMessage.parentMessage,
      content: content.text,
      attachments: content.attachments,
    };

    await action({ message: updatedMessage });
  };

  const onClose = () => {
    close();
    setEditMessage({ messageId: null });
  };

  return {
    onClose,
    onSubmit,
    isVisible,
    editedMessage,
  };
}
